// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3G2X8","label":"Radio_label__2f1nv","checkMark":"Radio_checkMark__md_7s","disabled":"Radio_disabled__2f57E"};